import { render, staticRenderFns } from "./PassengerflowView.vue?vue&type=template&id=af9dd0c8&scoped=true&"
import script from "./PassengerflowView.vue?vue&type=script&lang=js&"
export * from "./PassengerflowView.vue?vue&type=script&lang=js&"
import style0 from "./PassengerflowView.vue?vue&type=style&index=0&id=af9dd0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9dd0c8",
  null
  
)

export default component.exports